import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// public pages
import TopBar from "../components/TopBar/TopBar";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

import Home from "../components/Home/Home";

//  Course Details
import Course from "../components/Course/Course";
import FrontendDetails from "../components/FrontendDetails/FrontendDetails";
import BackendDetails from "../components/BackendDetails/BackendDetails";
import MernStackDetails from "../components/MernStackDetails/MernStackDetails";
// import DigitalMarketingDetails from "../components/DigitalMarketingDetails/DigitalMarketingDetails";
// import UIUXDesignerDetails from "../components/UIUXDesignerDetails/UIUXDesignerDetails";
// import DataAnalyticsDetails from "../components/DataAnalyticsDetails/DataAnalyticsDetails";

import Internshipprogramme from "../components/Internshipprogramme/Internshipprogramme";
import TutorProgramme from "../components/TutorProgramme/TutorProgramme";
import AboutUs from "../components/AboutUs/AboutUs";
import ContactUs from "../components/ContactUs/ContactUs";

import TermsConditions from "../components/TermsConditions/TermsConditions";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";

import NotFound from "../components/NotFound/NotFound";

// Scroll reveal only for public pages
function ScrollRevealWrapper() {
  const location = useLocation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.15 },
    );

    const elements = document.querySelectorAll(".reveal");
    elements.forEach((el) => {
      el.classList.remove("active"); // reset
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, [location.pathname]); // rerun on route change

  return null;
}

const PublicLayout = ({ children }) => {
  return (
    <>
      <TopBar />
      <Header />
      {children}
      <Footer />
    </>
  );
};

const PublicRoutes = () => {
  return (
    <HelmetProvider>
      <ScrollRevealWrapper />
      <Routes>
        {/* Home → TopBar + Footer only (skip Header) */}
        <Route
          path="/"
          element={
            <>
              <TopBar />
              <Home />
              <Footer />
            </>
          }
        />

        <Route
          path="/courses"
          element={
            <PublicLayout>
              <Course />
            </PublicLayout>
          }
        />

        {/* <Route
          path="/mern-stack"
          element={
            <PublicLayout>
              <MernStackDetails />
            </PublicLayout>
          }
        /> */}

        <Route
          path="/frontend-development"
          element={
            <PublicLayout>
              <FrontendDetails />
            </PublicLayout>
          }
        />

        <Route
          path="/backend-development"
          element={
            <PublicLayout>
              <BackendDetails />
            </PublicLayout>
          }
        />

        {/* <Route
          path="/digital-marketing"
          element={
            <PublicLayout>
              <DigitalMarketingDetails />
            </PublicLayout>
          }
        />  */}

        {/* <Route
          path="/uiux-designer"
          element={
            <PublicLayout>
              <UIUXDesignerDetails />
            </PublicLayout>
          }
        /> */}

        {/* <Route
          path="/data-analytics"
          element={
            <PublicLayout>
              <DataAnalyticsDetails />
            </PublicLayout>
          }
        /> */}

        <Route
          path="/internship-programme"
          element={
            <PublicLayout>
              <Internshipprogramme />
            </PublicLayout>
          }
        />

        <Route
          path="/tutor-programme"
          element={
            <PublicLayout>
              <TutorProgramme />
            </PublicLayout>
          }
        />

        <Route
          path="/about"
          element={
            <PublicLayout>
              <AboutUs />
            </PublicLayout>
          }
        />

        <Route
          path="/contact"
          element={
            <PublicLayout>
              <ContactUs />
            </PublicLayout>
          }
        />

        <Route
          path="/terms"
          element={
            <PublicLayout>
              <TermsConditions />
            </PublicLayout>
          }
        />

        <Route
          path="/privacy"
          element={
            <PublicLayout>
              <PrivacyPolicy />
            </PublicLayout>
          }
        />

        {/* Catch all wrong student routes */}
        <Route
          path="*"
          element={
            <PublicLayout>
              <NotFound />
            </PublicLayout>
          }
        />
      </Routes>
    </HelmetProvider>
  );
};

export default PublicRoutes;
